import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip,
  type ChartData,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import type { DailyProfitDayRow } from '../../lib/dailyProfitReport';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

interface DailyProfitChartProps {
  days: DailyProfitDayRow[];
  className?: string;
}

export default function DailyProfitChart({ days, className }: DailyProfitChartProps) {
  const labels = days.map((day) => day.label);
  const profits = days.map((day) => day.profit);
  const backgroundColor = profits.map((profit) =>
    profit >= 0 ? 'rgba(16, 185, 129, 0.85)' : 'rgba(239, 68, 68, 0.85)'
  );

  const chartData: ChartData<'bar', number[], string> = {
    labels,
    datasets: [
      {
        label: 'Daily profit',
        data: profits,
        backgroundColor,
        borderRadius: 4,
        maxBarThickness: 18,
      },
    ],
  };

  return (
    <div className={`h-[220px] w-full ${className ?? ''}`}>
      <Bar
        data={chartData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (ctx) => {
                  const day = days[ctx.dataIndex];
                  if (!day) return '';
                  return [
                    `Profit: ${ctx.formattedValue}`,
                    `Revenue: ${day.revenue.toFixed(2)}`,
                    `Labor: ${day.labor.toFixed(2)}`,
                    `Overhead: ${day.overheadExpenses.toFixed(2)}`,
                    `Direct: ${day.directExpenses.toFixed(2)}`,
                  ];
                },
              },
            },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: {
                maxRotation: 0,
                autoSkip: true,
                maxTicksLimit: 16,
                font: { size: 10 },
              },
            },
            y: {
              grid: { color: 'rgba(0,0,0,0.06)' },
              ticks: {
                font: { size: 10 },
              },
            },
          },
        }}
      />
    </div>
  );
}
